import React from 'react';
import { MapIconContainer } from './MapIcon.css.js';

const MapIcon = ({ area, fnAreaEdit }) => {
  return (
    <>
      <MapIconContainer onClick={() => fnAreaEdit(area)}
                        xcoordinate={area.xcoordinate} 
                        ycoordinate={area.ycoordinate}
                        >
        <div className="areaBox">
          <div className="areaName">
            <p>{area.areaNm}</p>
          </div>
        </div>
        <img src='' alt="icon" title={area.areaNm} />
      </MapIconContainer>
    </>
  )
}

export default MapIcon;